import { MenuItemType } from '@utils/types'
import { DownloadLink } from '../../atoms'
import styles from './DownloadList.module.sass'
import { useMemo } from 'react'

interface Props {
  item: MenuItemType
  searchValue?: string
  className?: string
  context?: 'default' | 'accordion'
}

const DownloadList = (props: Props) => {
  const { item = undefined, className = '', context = 'default', searchValue = '' } = props

  let searchResults = useMemo(
    () =>
      (item?.children || [])?.filter(
        (x) =>
          !searchValue || x.name?.toLocaleLowerCase()?.includes(searchValue.toLocaleLowerCase())
      ),
    [searchValue]
  )

  return searchResults?.length ? (
    <div className={`${styles.root} ${className}`}>
      <div className={`${styles.layout}`}>
        <div className={styles.main}>
          {!!item.name && (
            <>
              {context === 'accordion' ? (
                <h4 className={styles.title}>{item.name}</h4>
              ) : (
                <h3 className={styles.title}>{item.name}</h3>
              )}
            </>
          )}
          <div className={styles.content}>
            {searchResults?.length > 0 &&
              searchResults.map((i) => <DownloadLink key={i.pk} item={i} />)}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default DownloadList
